// @ts-nocheck
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { WorkItem } from '../models/workItem';

export const generateWorkItemPDF = (workItem: WorkItem, address: string) => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.text('Work Estimate', 10, 10);

  // Address
  doc.setFontSize(12);
  doc.text(`Address: ${address}`, 10, 20);

  // Initialize Totals
  let totalLaborEstimateLow = 0;
  let totalLaborEstimateHigh = 0;
  let totalMaterialEstimateLow = 0;
  let totalMaterialEstimateHigh = 0;

  // Process Line Items
  const lineItems = workItem.inspectionQuote?.analysis?.lineItems || [];
  const lineItemData = lineItems.map((lineItem) => {
    let laborEstimateLow = 0;
    let laborEstimateHigh = 0;
    let materialEstimateLow = 0;
    let materialEstimateHigh = 0;

    // Calculate costs for each sub-task
    lineItem.analysis.subTasks.forEach((subTask) => {
      subTask.options.forEach((option) => {
        // Labor cost for this option
        laborEstimateLow += option.expectedLaborHoursLow * option.laborCostLowPerHour;
        laborEstimateHigh += option.expectedLaborHoursHigh * option.laborCostHighPerHour;

        // Material cost for this option
        materialEstimateLow += option.materials.reduce(
          (acc, material) => acc + material.lowCostPerUnit * material.quantityLow,
          0
        );
        materialEstimateHigh += option.materials.reduce(
          (acc, material) => acc + material.highCostPerUnit * material.quantityHigh,
          0
        );
      });
    });

    // Round the individual line item totals
    const roundedLaborEstimateLow = Math.ceil(laborEstimateLow);
    const roundedLaborEstimateHigh = Math.ceil(laborEstimateHigh);
    const roundedMaterialEstimateLow = Math.ceil(materialEstimateLow);
    const roundedMaterialEstimateHigh = Math.ceil(materialEstimateHigh);
    const totalEstimateLow = roundedLaborEstimateLow + roundedMaterialEstimateLow;
    const totalEstimateHigh = roundedLaborEstimateHigh + roundedMaterialEstimateHigh;

    // Add rounded values to grand totals
    totalLaborEstimateLow += roundedLaborEstimateLow;
    totalLaborEstimateHigh += roundedLaborEstimateHigh;
    totalMaterialEstimateLow += roundedMaterialEstimateLow;
    totalMaterialEstimateHigh += roundedMaterialEstimateHigh;

    // Prepare data for this line item
    const materials = lineItem.analysis.subTasks
      .flatMap((subTask) =>
        subTask.options.flatMap((option) =>
          option.materials.map((material) => `${material.description}`)
        )
      )
      .join(', ');

    return [
      lineItem.description,
      materials || 'N/A',
      `$${roundedLaborEstimateLow.toLocaleString()} - $${roundedLaborEstimateHigh.toLocaleString()}`,
      `$${roundedMaterialEstimateLow.toLocaleString()} - $${roundedMaterialEstimateHigh.toLocaleString()}`,
      `$${totalEstimateLow.toLocaleString()} - $${totalEstimateHigh.toLocaleString()}`,
    ];
  });

  // Calculate Grand Total
  const totalEstimateLow = totalLaborEstimateLow + totalMaterialEstimateLow;
  const totalEstimateHigh = totalLaborEstimateHigh + totalMaterialEstimateHigh;

  // Total Estimated Cost
  doc.text(
    `Total Estimated Cost: $${totalEstimateLow.toLocaleString()} - $${totalEstimateHigh.toLocaleString()}`,
    10,
    30
  );

  // Line Items Table
  if (lineItems.length > 0) {
    doc.autoTable({
      startY: 40,
      head: [
        ['Task', 'Material(s)', 'Labor Estimate', 'Material Estimate', 'Total Estimate'],
      ],
      body: lineItemData,
      headStyles: {
        fillColor: '#131E3A', // Dark blue header color
        textColor: '#FFFFFF', // White text for contrast
      },
      columnStyles: {
        0: { cellWidth: 40 }, // Task column
        1: { cellWidth: 50 }, // Materials column (smaller)
        2: { cellWidth: 30 }, // Labor Estimate column
        3: { cellWidth: 30 }, // Material Estimate column
        4: { cellWidth: 30 }, // Total Estimate column
      },
      styles: {
        fontSize: 10, // Adjust font size for better fit
        cellPadding: 2, // Add some padding for readability
      },
    });
  } else {
    doc.text('No line items available.', 10, 40);
  }

  // Save PDF
  doc.save(`WorkItem_${workItem.id}.pdf`);
};

export default {
  generateWorkItemPDF,
} as const;
